import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link, IndexLink } from 'react-router';

class Contact extends React.Component {
   render() {
      return (
         <div className="Contact" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/contact/" activeStyle={{ color: 'red' }} >Contact</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to="/contact/" activeStyle={{ color: 'red' }} >All</IndexLink>
                  </li>
                  <li>
                     <Link to="/contact/newContact" activeStyle={{ color: 'red' }} >New</Link>
                  </li>
                  <li>
                     <Link to="/contact/salesDue" activeStyle={{ color: 'red' }} >Sales Due</Link>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

Contact.propTypes = {
   children: PropTypes.object
};

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/Contact.js
 **/